var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6952_23751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.724687 16.7967C0.723891 19.6534 1.47614 22.4427 2.90653 24.9013L0.587891 33.3014L9.25152 31.0474C11.6478 32.3417 14.3326 33.0199 17.0609 33.0201H17.0681C26.0747 33.0201 33.4064 25.748 33.4102 16.8095C33.412 12.4782 31.7136 8.40533 28.6278 5.34112C25.5426 2.27716 21.4393 0.588891 17.0674 0.586914C8.05966 0.586914 0.728539 7.8587 0.72482 16.7967",
    fill: "url(#paint0_linear_6952_23751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.142109 16.7913C0.14118 19.7507 0.920391 22.6398 2.40178 25.1864L0 33.8876L8.97427 31.5528C11.447 32.8905 14.231 33.5958 17.0639 33.5969H17.0712C26.401 33.5969 33.996 26.0631 34 16.8047C34.0016 12.3178 32.2421 8.09846 29.0461 4.92447C25.8497 1.75087 21.5997 0.00184496 17.0712 0C7.73978 0 0.145828 7.53271 0.142109 16.7913ZM5.48662 24.7478L5.15153 24.22C3.74292 21.9976 2.99944 19.4294 3.0005 16.7923C3.00342 9.09685 9.3152 2.83597 17.0765 2.83597C20.8351 2.83755 24.3674 4.29138 27.0242 6.92915C29.6808 9.56718 31.1427 13.0739 31.1417 16.8036C31.1383 24.4991 24.8264 30.7608 17.0712 30.7608H17.0656C14.5404 30.7595 12.0639 30.0866 9.90409 28.815L9.39011 28.5126L4.06459 29.898L5.48662 24.7478Z",
    fill: "url(#paint1_linear_6952_23751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8396 9.77159C12.5227 9.07274 12.1892 9.05864 11.8879 9.04639C11.6411 9.03584 11.359 9.03663 11.0772 9.03663C10.7951 9.03663 10.3368 9.14193 9.94934 9.56166C9.56153 9.98178 8.46875 10.997 8.46875 13.0619C8.46875 15.1269 9.98454 17.1226 10.1958 17.4029C10.4074 17.6827 13.1221 22.0557 17.4215 23.7381C20.9947 25.1362 21.7218 24.8581 22.4973 24.788C23.273 24.7181 25.0001 23.773 25.3524 22.7929C25.705 21.813 25.705 20.973 25.5993 20.7975C25.4936 20.6226 25.2115 20.5176 24.7885 20.3078C24.3655 20.098 22.2858 19.0824 21.8981 18.9424C21.5103 18.8024 21.2283 18.7326 20.9462 19.1528C20.6641 19.5724 19.8541 20.5176 19.6072 20.7975C19.3606 21.078 19.1137 21.113 18.6908 20.903C18.2675 20.6924 16.9053 20.2498 15.2891 18.8201C14.0316 17.7076 13.1827 16.3337 12.9359 15.9135C12.6891 15.4939 12.9095 15.2664 13.1216 15.0573C13.3116 14.8692 13.5447 14.5672 13.7564 14.3222C13.9673 14.0771 14.0377 13.9022 14.1788 13.6223C14.3199 13.3421 14.2493 13.097 14.1437 12.8871C14.0377 12.6771 13.2157 10.6014 12.8396 9.77159Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6952_23751",
    x1: 1641.71,
    y1: 3272.03,
    x2: 1641.71,
    y2: 0.586914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6952_23751",
    x1: 1700,
    y1: 3388.76,
    x2: 1700,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6952_23751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.60685d375233493b17c5a34e25bd410c.svg";
export { ForwardRef as ReactComponent };